import { EmailTemplate } from "@type/setting";

/**
 * Merges BE-returned templates with hardcoded fallback defaults.
 * If the BE has a saved override for a default template (matched by template_id),
 * the BE version takes precedence. Otherwise the hardcoded fallback is used.
 * Custom (non-default) templates from the BE are appended at the end.
 */
export const mergeEmailTemplates = (
    beTemplates: EmailTemplate[],
    hardcodedDefaults: EmailTemplate[]
): EmailTemplate[] => {
    const beDefaultsMap = new Map(
        beTemplates
            .filter((t) => t.is_default && t.template_id)
            .map((t) => [t.template_id as string, t])
    );

    const mergedDefaults = hardcodedDefaults.map(
        (hardcoded) => beDefaultsMap.get(hardcoded.template_id as string) ?? hardcoded
    );

    const customTemplates = beTemplates.filter((t) => !t.is_default);

    return [...mergedDefaults, ...customTemplates];
};
